import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "./QuoteForm.css";

const QuoteForm = ({ isOpen, onClose,title,subtitle }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    description: "",
    source: ""
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        description: "",
        source: ""
      });
      setSubmitted(false);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.fullName ||
      !formData.email ||
      !formData.phone ||
      !formData.description ||
      !formData.source
    ) {
      alert("Please fill all fields.");
      return;
    }

    setLoading(true);

    try {
      await emailjs.send(
        "service_y8mxsus",
        "template_q8f3kza",
        {
          from_name: formData.fullName,
          from_email: formData.email,
          phone: formData.phone,
          source: formData.source,
          description: formData.description,
        },
        "A_WU_S7CLE6e7VBE1"
      );
      setSubmitted(true);
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        description: "",
        source: ""
      });
    } catch (err) {
      console.error("Error sending email:", err);
      alert("Failed to send message.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="sqf-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className="sqf-modal" onClick={(e) => e.stopPropagation()}>
        <button className="sqf-close" onClick={onClose}>
          ×
        </button>

        {!submitted ? (
          <div className="sqf-form" >
            <h3 className="heading-form">{title}</h3>
            <p className="subtitle2">{subtitle}</p>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name*"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email*"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone*"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <textarea
              name="description"
              placeholder="Describe your product*"
              value={formData.description}
              onChange={handleChange}
              required
            />
            <select
              name="source"
              value={formData.source}
              onChange={handleChange}
              required
            >
              <option value="">How did you hear about us?*</option>
              <option value="Facebook">Facebook</option>
              <option value="Instagram">Instagram</option>
              <option value="LinkedIn">LinkedIn</option>
              <option value="Twitter">Twitter</option>
              <option value="WhatsApp">WhatsApp</option>
              <option value="Friend">Friend</option>
            </select>

            <button
              onClick={handleSubmit}
              disabled={loading}
              // Fix for mobile tap issues
              onTouchStart={(e) => e.stopPropagation()}
            >
              {loading ? "Sending..." : "Submit"}
            </button>
          </div>
        ) : (
          <div className="sqf-success">
            <h3>Thank you!</h3>
            <p>Your request was sent successfully.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteForm;
